declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


import { FieldData } from '../../../../../../models/actor/actor';


@Component({
    selector: 'auto-gen-text',
    templateUrl: './autogentext.component.html',
    styleUrls: ['./autogentext.component.scss']
})

export class AutoGenTextComponent implements OnInit {
    @Input() public mode;
    @Input() public field: FieldData;
    ngOnInit(): void {
        //if (this.mode != 'view')
        //    this.mode = 'edit';
        
    }
}
